import { PBox } from "../../theme/BaseTheme";
import { FeatureImageLeft } from "../../sections/FeatureImageLeft";
import { FeatureImageRight } from "../../sections/FeatureImageRight";
import { SellFaq } from "../../sections/SellFaq";
import UseCases from "../../sections/UseCases";

const sketch_filter_faq_data = [
    {
        question: "What is a sketch filter or effect?",
        answer: "A sketch filter or effect can also be described as a digital filter that transforms a normal photo into an art piece that looks like a sketch made by hand.",
    },
    {
        question: "How to convert a portrait photo into a sketch?",
        answer: "Upload your portrait photo to our photo-to-sketch converter, and apply the AI sketch filter, and you will see how your photo has changed in a few seconds.",
    },
    {
        question: "How do I turn a picture into a pencil sketch?",
        answer: "To get a pencil sketch, just upload your image and then choose the pencil sketch option and the AI will process your photo.",
    },
    {
        question: "What about privacy? Are my photos safe?",
        answer: "Yes, your images are safe with us. Patternful.ai prioritizes user data safety. Your images are always private, proprietary, and they remain your property. All your uploaded images are automatically deleted from our servers after a few hours.",
    },
];

const sketch_filter_use_cases = [
    {
        title: "Portrait Photo",
        description:
            "It is very simple and efficient when it comes to converting photos with someone's portrait into a more detailed pencil sketch. Take attention from body features and poses towards face and facial expressions with an element of an artistically mastered artist.",
    },
    {
        title: "Landscape Photo",
        description:
            "Convert your outdoor landscape photos into lovely and detailed sketches with just a slight difference from the real-looking ones.",
    },
    {
        title: "Still Life Picture",
        description:
            "Turn still-life photos into enthralling sketches. Ideal for enhancing ordinary products and design at any given formation.",
    },
    {
        title: "Coloring Pages",
        description:
            "Turn an image into a sketch with clean lines. Ideal for printable coloring books for kids or adults.",
    },
    {
        title: "Tattoo Templates",
        description:
            "Use the image to sketch converter to prepare tattoo outlines with artistic shading and precision.",
    },
    {
        title: "Social Avatars",
        description:
            "Upgrade your profile picture by using a picture-to-sketch converter for a clean, stylish, hand-drawn vibe.",
    },
];

const SketchFilter = () => {
    return (
        <PBox>
            <FeatureImageLeft
                image={"/images/linkedin-headshot/Feature-1.webp"}
                title={"Photo to Sketch—AI Converts Photos into Hand-Drawn Art"}
                description={
                    "Creating sketches using AI makes your cherished memories look timeless. With insMind, you can turn a photo into a sketch that captures the emotion and detail of the original while adding a handmade, artistic touch. Meanwhile, our AI will find edges, contours, and shading that help to recreate the image with lifelike pencil strokes. It could be used to convert portraits, family photos, pet pictures, travel pictures, and so on. You can even use it to turn a picture into a sketch for products or social content. It's the easiest way to add elegance and charm to your visuals without needing a single art supply."
                }
            />
            <FeatureImageRight
                image={"/images/linkedin-headshot/Feature-1.webp"}
                title={
                    "Turn your portrait photo into a pencil sketch in an instant"
                }
                description={
                    "Turning photos into pencil portraits is as simple as clicking a few buttons, and it perfectly captures both art and beauty. Thanks to its unique AI sketch filter, it enhances complex facial features and expressions, giving your images a professional, hand-drawn appearance by leveraging our new AI photo-to-sketch filters. With insMind's AI-powered filters, just upload your photo, then select AI Filter and witness how our advanced AI system perfectly captures your image and transforms it into a sketch portrait from a photo, without you needing to learn how to draw at all!"
                }
            />
            <FeatureImageLeft
                image={"/images/linkedin-headshot/Feature-1.webp"}
                title={
                    "Create Perfect Artistic Image Sketches to Share on Social Media"
                }
                description={
                    "The direct sharing of the converted image is also given where one can share directly on such platforms as Facebook, and Instagram among others. Ideal for the focus on creativity, this option makes sure that your followers notice your artistic changes at once. Step up your social media feeds with sketch photos created using our photo to sketch online tool—look like a pro without any further editing needed."
                }
            />
            <FeatureImageRight
                image={"/images/linkedin-headshot/Feature-1.webp"}
                title={
                    "Convert Stunning Landscape Images into Perfect Pencil Sketches"
                }
                description={
                    "Convert your landscape photos to sketches using insMind's AI filters, and achieve a detailed and high-quality drawing in just a matter of seconds, The photo-to-sketch converter gives users the ability to turn outdoor photos into stunning pencil drawings that will make the outdoors pop in detail. If you're taking shots of mountains, seas, or cities, your landscape photographs will look far more artistic. insMind's advanced AI filter helps represent the beauty of your landscape and amplifies the scenery that you took a photo of. It perfectly details its surroundings and adapts it into a realistic sketch with fine lines and accurate shadows. bypassing hours of effort compared to traditional drawing."
                }
            />
            <UseCases
                data={sketch_filter_use_cases}
                title={"Creative and Pretty Sketch Filters for Everyone"}
            />
            <SellFaq data={sketch_filter_faq_data} />
        </PBox>
    );
};

export default SketchFilter;
